<div
    class="py-12 md:py-16 lg:py-20 p-6 bg-[url(assets/landing-new/images/bg-curve.svg)] bg-no-repeat bg-auto lg:bg-contain bg-top lg:bg-[center_top] sub-banner">
    <img src="assets/landing-new/icons/highlighter.svg" class="animate-float mx-auto" alt="">
    <div class="grid grid-cols-12 gap-4 container mx-auto py-8 lg:py-12" data-aos="fade-up"  data-aos-delay="200"  data-aos-easing="ease-in-out">
        <div class="col-span-12">
            <p
                class="text-xl md:text-2xl lg:text-3xl xl:text-4xl mi--font-regular text-white leading-normal lg:!leading-[1.16] text-center subtitle">
                We are bringing the power of <span class="text__yg--gradient">web3</span> back to the thinkers.<br />
                Create projects without ever touching code</p>
        </div>
    </div>
    <img src="assets/landing-new/icons/highlighter.svg" class="animate-float mx-auto" alt="">
</div>
